

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _squid = require('squid');

require('components/xo-models/src/auth/index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

_angular2['default'].module().run(function ($rootScope, $log, $state, $AuthModel, $Forbidden, $logger, $timeout, $interval) {

    var errorCount = 0;

    $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {

        var auth = $AuthModel.instance();

        if (toState.auth !== false && !auth.logged_in) {
            errorCount += 1;
            if (errorCount === 10) {
                $logger.error('max_state_requires_auth');
            }
            if (errorCount >= 10) {
                return;
            }
            $logger.warn('state_requires_auth', {
                stateName: toState.name
            });
            event.preventDefault();
            throw new $Forbidden('state_transition_forbidden', { fromState: fromState, toState: toState });
        }
    });

    $interval(function () {

        var auth = $AuthModel.instance();

        if (auth.logged_in) {
            auth.reload({
                silent: true
            }).then(function () {
                if ($state.current.auth !== false && !auth.logged_in) {
                    errorCount += 1;
                    if (errorCount === 10) {
                        $logger.error('max_state_requires_auth');
                    }
                    if (errorCount >= 10) {
                        return;
                    }
                    $logger.info('idle_timeout');
                    $logger.warn('state_requires_auth', {
                        stateName: $state.current.name
                    });
                    errorCount += 1;
                    throw new $Forbidden();
                }
            });
        }
    }, 30 * 60 * 1000);

    _squid.$util.idleTimeout(10 * 60 * 60 * 1000);
});

_squid.$util;


/*****************
 ** WEBPACK FOOTER
 ** ./js/lib/security.js
 ** module id = 164
 ** module chunks = 1
 **/